







import { Component, Vue } from 'vue-property-decorator';
import RegisterForm from '@/components/Account/RegisterForm.vue';
import MountainBox from '@/components/MountainBox.vue';
import Logo from '@/components/Logo.vue';

@Component({
  components: {
    RegisterForm,
    MountainBox,
    Logo,
  },
})
export default class Register extends Vue {

}
